import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, ChevronLeft } from 'lucide-react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

const TermsOfUse = () => {
  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 bg-gradient-to-br from-[#0a0a1a] via-[#0d1a2d] to-[#0a0a1a]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-[#00C0FF] hover:text-white transition-colors mb-6">
            <ChevronLeft className="w-4 h-4" />
            Back to Home
          </Link>
          <div className="flex items-center gap-4 mb-4">
            <div className="w-12 h-12 bg-[#0066CC]/20 rounded-xl flex items-center justify-center">
              <FileText className="w-6 h-6 text-[#00C0FF]" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-white">Terms of Use</h1>
          </div>
          <p className="text-gray-400">Last updated: January 2026</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            
            <h2 className="text-2xl font-bold text-[#1a1a5c] mt-8 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-600 mb-6">
              By accessing and using the SRAGCircle OPC website ("Website"), you accept and agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use our Website.
            </p>

            <h2 className="text-2xl font-bold text-[#1a1a5c] mt-8 mb-4">2. Use of Website</h2>
            <p className="text-gray-600 mb-4">You agree to use this Website only for lawful purposes and in a manner that does not:</p>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>Violate any applicable local, national, or international law or regulation</li>
              <li>Infringe upon the rights of others</li>
              <li>Interfere with or disrupt the Website or servers</li>
              <li>Attempt to gain unauthorized access to any part of the Website</li>
              <li>Transmit any harmful code, viruses, or malicious software</li>
            </ul>

            <h2 className="text-2xl font-bold text-[#1a1a5c] mt-8 mb-4">3. Services Information</h2>
            <p className="text-gray-600 mb-6">
              The information provided on this Website about our products and services is for general informational purposes only. While we strive to keep the information accurate and up-to-date, we make no representations or warranties of any kind about the completeness, accuracy, reliability, or availability of the information.
            </p>

            <h2 className="text-2xl font-bold text-[#1a1a5c] mt-8 mb-4">4. Quotations and Pricing</h2>
            <p className="text-gray-600 mb-6">
              Any quotations or pricing information provided through this Website or via inquiry forms are estimates only and subject to change. Final pricing will be confirmed in writing through official quotations or contracts issued by SRAGCircle OPC.
            </p>

            <h2 className="text-2xl font-bold text-[#1a1a5c] mt-8 mb-4">5. Contact Form Submissions</h2>
            <p className="text-gray-600 mb-6">
              When you submit information through our contact form, you consent to SRAGCircle OPC storing and processing this information to respond to your inquiry. We will handle your information in accordance with our Privacy Policy.
            </p>

            <h2 className="text-2xl font-bold text-[#1a1a5c] mt-8 mb-4">6. Third-Party Links</h2>
            <p className="text-gray-600 mb-6">
              Our Website may contain links to third-party websites. These links are provided for your convenience only. SRAGCircle OPC has no control over the content of these sites and accepts no responsibility for them or for any loss or damage that may arise from your use of them.
            </p>

            <h2 className="text-2xl font-bold text-[#1a1a5c] mt-8 mb-4">7. Limitation of Liability</h2>
            <p className="text-gray-600 mb-6">
              To the fullest extent permitted by law, SRAGCircle OPC shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of the Website.
            </p>

            <h2 className="text-2xl font-bold text-[#1a1a5c] mt-8 mb-4">8. Modifications</h2>
            <p className="text-gray-600 mb-6">
              SRAGCircle OPC reserves the right to modify these Terms of Use at any time. Changes will be effective immediately upon posting to the Website. Your continued use of the Website after any changes constitutes acceptance of the modified terms.
            </p>

            <h2 className="text-2xl font-bold text-[#1a1a5c] mt-8 mb-4">9. Governing Law</h2>
            <p className="text-gray-600 mb-6">
              These Terms of Use shall be governed by and construed in accordance with the laws of the Republic of the Philippines. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts in Metro Manila, Philippines.
            </p>

            <h2 className="text-2xl font-bold text-[#1a1a5c] mt-8 mb-4">10. Contact Information</h2>
            <p className="text-gray-600 mb-6">
              If you have any questions about these Terms of Use, please contact us at:
            </p>
            <div className="bg-gray-50 p-6 rounded-xl">
              <p className="text-gray-700 font-semibold">SRAGCircle OPC</p>
              <p className="text-gray-600">Email: contact@sragcircle.com</p>
              <p className="text-gray-600">Phone: (63) 926 036 6898</p>
              <p className="text-gray-600">Location: Metro Manila, Philippines</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsOfUse;
